var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon',{attrs:{"name":`fa ${this.name}`,"size":"sm"}})
}
var staticRenderFns = []

export { render, staticRenderFns }